import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import Raven from 'raven-js';

// AI Access Control Types
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Returns the AI access controls required for agents.
 */
const getAccessControlsRequiredForCustomerAgent = () => ['CONVERSATION_DATA'];
export const getAccessControlsRequiredForAgents = () => ['GENERATIVE_AI', 'CRM_PROPERTIES', 'CONVERSATION_DATA', 'FILE_DATA'];
export const getAccessControlsRequiredForAssistants = () => [...getAccessControlsRequiredForAgents(), 'COPILOT'];
const getControlTypeKey = controlType => {
  switch (controlType) {
    case 'GENERATIVE_AI':
      return 'generativeAiEnabled';
    case 'CRM_PROPERTIES':
      return 'crmPropertiesEnabled';
    case 'CONVERSATION_DATA':
      return 'conversationDataEnabled';
    case 'FILE_DATA':
      return 'fileDataEnabled';
    case 'COPILOT':
      return 'copilotEnabled';
    default:
      {
        const errorMessage = 'Cannot get control type key for control type';
        Raven.captureMessage(errorMessage, {
          extra: {
            controlType
          }
        });
        throw new Error(errorMessage);
      }
  }
};
export const getControlTypeText = controlType => {
  switch (controlType) {
    case 'GENERATIVE_AI':
      return I18n.text('detailsPage.aiAccessControls.controlTypes.GENERATIVE_AI');
    case 'CRM_PROPERTIES':
      return I18n.text('detailsPage.aiAccessControls.controlTypes.CRM_PROPERTIES');
    case 'CONVERSATION_DATA':
      return I18n.text('detailsPage.aiAccessControls.controlTypes.CONVERSATION_DATA');
    case 'FILE_DATA':
      return I18n.text('detailsPage.aiAccessControls.controlTypes.FILE_DATA');
    case 'COPILOT':
      return I18n.text('detailsPage.aiAccessControls.controlTypes.COPILOT');
    default:
      {
        const errorMessage = 'Cannot get control type text for control type';
        Raven.captureMessage(errorMessage, {
          extra: {
            controlType
          }
        });
        throw new Error(errorMessage);
      }
  }
};
export const getMissingAccessControls = (accessControls, requiredControls) => {
  return requiredControls.filter(controlType => !accessControls[getControlTypeKey(controlType)]);
};
export const getAiAccessControlsTooltip = (accessControls, agentType, LinkComponent, sourceId) => {
  if (!accessControls) {
    return null;
  }
  const requiredControls = sourceId === 'breeze-customer-agent' ? getAccessControlsRequiredForCustomerAgent() : agentType === 'ASSISTANT' ? getAccessControlsRequiredForAssistants() : getAccessControlsRequiredForAgents();
  const missingControls = getMissingAccessControls(accessControls, requiredControls);
  if (missingControls.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "detailsPage.aiAccessControls.description_jsx",
    elements: {
      Link: LinkComponent
    },
    options: {
      settings: missingControls.map(control => getControlTypeText(control)).join(', ')
    }
  });
};